import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {IconChevronNext, IconDownload} from '@wandb/weave/components/Icon';
import React, {useCallback, useState} from 'react';

import {ImageExportType} from '../../util/panelExport';
import {isExportableAs} from '../../util/panels';
import {getPanelSpec} from '../../util/panelTypes';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {ExportType} from './PanelActionsMenu';
import {usePanelContext} from './PanelContextProvider';

interface PanelExportMenuProps {
  ref: React.RefObject<HTMLElement>;
  panelSpec: ReturnType<typeof getPanelSpec>;
  handleClose(): void;
  setExportType(type: ExportType): void;
  setImageExportType(imageType: ImageExportType): void;
}

export const PanelExportMenu = React.forwardRef<
  HTMLElement,
  PanelExportMenuProps
>(({panelSpec, handleClose, setExportType, setImageExportType}, ref) => {
  const {trackPanelControls} = usePanelContext();
  const onExportImageClick = useCallback(
    (imageType: ImageExportType) => {
      setExportType(ExportType.Image);
      setImageExportType(imageType);
      handleClose();
      trackPanelControls({
        action: 'Panel exported',
        exportType: imageType,
      });
    },
    [handleClose, setExportType, setImageExportType, trackPanelControls]
  );

  const onExportClick = useCallback(
    (exportType: ExportType) => {
      setExportType(exportType);
      handleClose();
      trackPanelControls({
        action: 'Panel exported',
        exportType: 'csv',
      });
    },
    [handleClose, setExportType, trackPanelControls]
  );

  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu.Sub open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.SubTrigger>
        <div className="flex w-full items-center gap-10">
          <IconDownload />
          Download
          <IconChevronNext className="ml-auto text-moon-450" />
        </div>
      </DropdownMenu.SubTrigger>
      <DropdownMenu.Portal>
        {/* zIndex is needed so the dropdown is above the panel in reports */}
        <DropdownMenu.SubContent style={{zIndex: 1}}>
          {isExportableAs(panelSpec, 'csv') && (
            <DropdownMenu.Item
              title="CSV"
              onClick={() => onExportClick(ExportType.CSV)}>
              CSV
            </DropdownMenu.Item>
          )}
          {isExportableAs(panelSpec, 'image') && (
            <>
              <DropdownMenu.Item
                onClick={() => onExportImageClick(ImageExportType.PNG)}>
                PNG
              </DropdownMenu.Item>
              <DropdownMenu.Item
                onClick={() => onExportImageClick(ImageExportType.PDF)}>
                PDF
              </DropdownMenu.Item>
              <DropdownMenu.Item
                onClick={() => onExportImageClick(ImageExportType.SVG)}>
                SVG
              </DropdownMenu.Item>
            </>
          )}
        </DropdownMenu.SubContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Sub>
  );
});
